// extracted by mini-css-extract-plugin
export default {"gift_cabinet":"gift_cabinet_gift_cabinet__viAkO"};